var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('nav',{staticClass:"nav",attrs:{"color":"transparent"}},[_c('h1',{staticClass:"logo"},[_vm._v("Weathery.")]),_c('v-spacer'),_c('Tabs'),_c('Settings')],1),_c('Warnings'),_c('Loading'),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }